import { Icon } from '#/components/Icon/Icon';
import { Text } from '#/components/Text/Text';
import { colors, fontWeights } from '#/theme/theme';

import type { LocationSuggestion } from './LocationSuggestion';

type Props = {
  suggestion: LocationSuggestion;
};

export function LocationInputSuggestion({ suggestion }: Props) {
  return (
    <div
      className="idlst-google-suggestion"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <div style={{ marginRight: '5px' }}>
        <Icon
          name={suggestion.isRemoteOption ? 'house' : 'location'}
          size={18}
        />
      </div>

      <div
        style={{ display: 'flex', alignItems: 'baseline', overflow: 'hidden' }}
      >
        <Text
          styleAs="bodyMicro"
          style={{
            whiteSpace: 'nowrap',
            fontWeight: fontWeights.semiBold,
            marginRight: '5px',
          }}
        >
          {suggestion.placePrediction?.mainText?.text}
        </Text>
        <Text
          styleAs="bodyMicro"
          style={{ whiteSpace: 'nowrap', color: colors.lightContentGrey }}
        >
          {suggestion.placePrediction?.secondaryText?.text}
        </Text>
      </div>
    </div>
  );
}
